// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1H8Nl","alert":"SettungsInbox_alert__19wDt"};